import { render, staticRenderFns } from "./cans.vue?vue&type=template&id=8f6b2e2a&scoped=true&"
import script from "./cans.vue?vue&type=script&lang=js&"
export * from "./cans.vue?vue&type=script&lang=js&"
import style0 from "./cans.vue?vue&type=style&index=0&id=8f6b2e2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6b2e2a",
  null
  
)

export default component.exports